module.exports = __webpack_public_path__ + "static/media/depression_no.cb58bc49.svg";